import React from "react";
import { string, number, array, func, bool, object } from "prop-types";
import { LoadMoreCollectionStories } from "@quintype/components";

import Stories2AdWithLoadMore from "../Stories2AdWithLoadMore";

const NO_OF_STORIES_TO_LOAD = 20;

const SixteenStories1WidgetWithPollAndLoadMore = ({
  collectionSlug,
  widgetUrl,
  widgetHeight,
  stories,
  sectionsDataForHeader,
}) => {
  const list = stories.map((story) => story);
  const storiesSet = list.map(({ story }) => story).slice(0, 20);

  return (
    <div>
      <LoadMoreCollectionStories
        collectionSlug={collectionSlug}
        template={MoreCollectionStories}
        data={{ stories: storiesSet, widgetUrl, widgetHeight, sectionsDataForHeader }}
        numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
      />
    </div>
  );
};

const MoreCollectionStories = ({
  stories,
  widgetUrl,
  widgetHeight,
  onLoadMore,
  loading,
  noMoreStories,
  sectionsDataForHeader,
}) => (
  <Stories2AdWithLoadMore
    list={stories}
    loading={loading}
    onLoadMore={onLoadMore}
    isMoreStories={NO_OF_STORIES_TO_LOAD <= stories.length && !noMoreStories}
    widgetUrl={widgetUrl}
    widgetHeight={widgetHeight}
    sectionsDataForHeader={sectionsDataForHeader}
  />
);

SixteenStories1WidgetWithPollAndLoadMore.propTypes = {
  stories: array,
  collectionSlug: string,
  widgetUrl: string,
  widgetHeight: string,
  sectionsDataForHeader: object,
};

MoreCollectionStories.propTypes = {
  stories: array.isRequired,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
  widgetUrl: string,
  widgetHeight: string,
  sectionsDataForHeader: object,
};

SixteenStories1WidgetWithPollAndLoadMore.storyLimit = 20;

export default SixteenStories1WidgetWithPollAndLoadMore;
